import { dia } from "@clientio/rappid";
import RappidContext from "../../rappid/rappid-context";

export abstract class Controller {
  constructor(
    protected view: dia.CellView,
    protected context: RappidContext
  ) {
    this.view.on("batchcommand:init", () => {
      context.commandManager.initBatchCommand();
    });
    this.view.on("batchcommand:store", () => {
      context.commandManager.storeBatchCommand();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract on(event: string, payload?: any): void;
}
